/**
 * options for ynamicComponentModule
 */
var DynamicComponentOptions = (function () {
    function DynamicComponentOptions() {
    }
    return DynamicComponentOptions;
}());
export { DynamicComponentOptions };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/ng-dynamic/src/dynamic-component/options.js
// module id = ../../../../ng-dynamic/src/dynamic-component/options.js
// module chunks = 3